import { render, staticRenderFns } from "./ms-drug-msg.vue?vue&type=template&id=3cc24aa0&scoped=true"
import script from "./ms-drug-msg.vue?vue&type=script&lang=js"
export * from "./ms-drug-msg.vue?vue&type=script&lang=js"
import style0 from "./ms-drug-msg.vue?vue&type=style&index=0&id=3cc24aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc24aa0",
  null
  
)

export default component.exports